var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFullModel),expression:"!isFullModel"}],staticClass:"kefu",on:{"click":_vm.service}},[_c('img',{staticClass:"myIcon",attrs:{"src":require("@/assets/images/icondaohanglan_kefu_bai.png")}}),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.$t('meeting.kf')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }